import { useMutation } from 'react-query';
import { useToast } from 'hooks/useToast';
import { trackGroupConfigAction } from 'services/analytics/trackGroupConfigAction';
import { useDashboard, useDashboardGroupType } from 'state/dashboard';
import { GROUP_TYPE } from 'utils/constants';

type TSaveGroupParams = {
  onSuccessCallback?: (arg0: number) => void;
  onErrorCallback?: () => void;
};

export const useSaveGroup = () => {
  const [type] = useDashboardGroupType();
  const { saveGroup: executeSaveGroupRequest } = useDashboard();
  const { renderCustomToast: toast } = useToast();

  const onError = (onErrorCallback?: () => void) => {
    if (onErrorCallback) {
      onErrorCallback();
    }
    toast({
      title: 'Error',
      description: 'Something went wrong - Saved search creation failed',
      status: 'error',
    });
  };

  const saveGroup = useMutation({
    mutationFn: async ({ onSuccessCallback, onErrorCallback }: TSaveGroupParams) => {
      const response = await executeSaveGroupRequest();
      if (response?.status === 201) {
        toast({
          title: 'Success',
          description: 'Saved search created successfully',
          status: 'success',
        });
        const newGroupId = response.data?.data?.group_config_id;
        if (newGroupId != null) {
          trackGroupConfigAction({
            group_id: String(newGroupId),
            group_type: type === GROUP_TYPE.PROJECT ? 'project_group' : 'company_group',
            click_action: 'create_group',
          });
          onSuccessCallback?.(newGroupId);
        }
      } else {
        onError(onErrorCallback);
      }
    },
    onError: (_, { onErrorCallback }) => {
      onError(onErrorCallback);
    },
  });

  return { saveGroup };
};
